export enum deviceType {
  resistanceWheel = 'resistanceWheel',
  heartRate = 'heartRate',
  xyTool = 'xyTool',
  saddle = 'saddle',
  handlebar = 'handlebar',
}

export enum deviceProtocol {
  ANT = 'ANT',
  BLE = 'BLE',
}

export enum motorStatus {
  OK = 'MOTOR_STATE_OK',
  ACTIVE = 'MOTOR_STATE_ACTIVE',
  OVERCURRENT = 'MOTOR_STATE_OVERCURRENT',
  STALLED = 'MOTOR_STATE_STALLED',
  LIMIT_SWITCH_ERROR = 'MOTOR_STATE_LIMIT_SWITCH_ERROR',
}

export enum motorOvercurrentStatus {
  TRUE = 'TRUE',
  FALSE = 'FALSE',
}

export enum motorStalledStatus {
  TRUE = 'TRUE',
  FALSE = 'FALSE',
}

export enum motorTemperatureStatus {
  TRUE = 'TRUE',
  FALSE = 'FALSE',
}

export interface baseDevice {
  name: string
  id: string
  type: string
  connecting: boolean
  connected: boolean
  lastSeen: number
}

export interface antDevice extends baseDevice {
  protocol: deviceProtocol.ANT
}

export interface bleDevice extends baseDevice {
  protocol: deviceProtocol.BLE
}
